module.exports = __webpack_public_path__ + "static/media/CycleTasks.12354929.svg";